import(/* webpackMode: "eager" */ "/codegiant-test/components/site-header.tsx")